import { cx } from 'classix'
import { ButtonBase } from '../Base/ButtonBase'
import type { ButtonProps } from '../Button.types'
import { BUTTON_VARIANT } from '../Button.types'
import { ButtonContentWrapper } from '../ButtonContentWrapper/ButtonContentWrapper'

import styles from './ButtonSecondary.module.css'

export function ButtonSecondary(props: Readonly<ButtonProps>): React.ReactNode {
	const {
		variant = BUTTON_VARIANT.DEFAULT,
		isLoading = false,
		className,
		children,
		disabled,
		fullWidth,
		accessibilityText,
		...rest
	} = props

	const disabledButton = disabled || isLoading

	return (
		<ButtonBase
			{...rest}
			fullWidth={fullWidth}
			className={cx(className, styles[variant])}
			disabled={disabledButton}
		>
			<ButtonContentWrapper
				isLoading={isLoading}
				variant={BUTTON_VARIANT.INVERSE}
				accessibilityText={accessibilityText}
			>
				{children}
			</ButtonContentWrapper>
		</ButtonBase>
	)
}
